import { Observable } from 'rxjs';
import {
  CollectionApiClient,
  IPaginationResponse,
  IPaginationParameters,
  ICreateEntitiesRequest
} from '../../../../core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserManagementCollections } from '../../../common';
import { UserContextService } from '../../../auth-management';
import { IAccountUsersApiClient } from './i-account-users.api.client';
import { ICreateUserRequest, IUserResponse } from '../../../system-management';
import { IChangeAccountUserPasswordRequest, IUpdateUserRequest } from '../dtos';

@Injectable({
  providedIn: 'root'
})
export class AccountUsersApiClient implements IAccountUsersApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(this.getCollectionUrl(), http);
  }

  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IUserResponse>> {
    return this.collectionApiClient.get({
      collectionName: this.getCollectionUrl(),
      paginationParameters
    });
  }

  getById(id: string): Observable<IUserResponse> {
    return this.collectionApiClient.get({
      collectionName: this.getCollectionUrl(),
      id
    });
  }

  create(request: ICreateUserRequest): Observable<IUserResponse> {
    return this.collectionApiClient.post({
      collectionName: this.getCollectionUrl(),
      body: request
    });
  }

  update(id: string, request: IUpdateUserRequest): Observable<void> {
    return this.collectionApiClient.put({
      collectionName: this.getCollectionUrl(),
      id,
      body: request
    });
  }

  assignSpecializedRoles(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return this.collectionApiClient.post({
      collectionName: this.getCollectionUrl(),
      id,
      resourceSegment: 'specialized-roles',
      body: request
    });
  }

  revokeSpecializedRoles(id: string, request: ICreateEntitiesRequest): Observable<void> {
    return this.collectionApiClient.delete({
      collectionName: this.getCollectionUrl(),
      id,
      resourceSegment: 'specialized-roles',
      body: request
    });
  }

  changePassword(id: string, request: IChangeAccountUserPasswordRequest): Observable<void> {
    return this.collectionApiClient.patch({
      collectionName: this.getCollectionUrl(),
      id,
      resourceSegment: 'change-password',
      body: request
    });
  }

  getCollectionUrl(): string {
    return UserManagementCollections.AccountUsers(UserContextService.getUserContext()?.accountId || '');
  }
}
